var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:{
    'option rounded-pill border px-3 py-2 fs-14px mr-2 mt-2': true,
    'border-primary bg-primary text-white': _vm.model === _vm.value && _vm.labelModel !== ''
},on:{"click":function($event){return _vm.selectOption()}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }